import type * as Types from '../../../../gql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type LockContentMutationVariables = Types.Exact<{
  input: Types.LockContentInput;
}>;


export type LockContentMutation = { __typename?: 'RootMutationType', lockContent: { __typename?: 'LockContentResult', result?: { __typename?: 'ContentLock', id: string, sourceId: string, lockType: string, schoolId: string } | null, errors: Array<{ __typename?: 'MutationError', message?: string | null }> } };

export type UnlockContentMutationVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type UnlockContentMutation = { __typename?: 'RootMutationType', unlockContent: { __typename?: 'UnlockContentResult', result?: { __typename?: 'ContentLock', id: string } | null, errors: Array<{ __typename?: 'MutationError', message?: string | null }> } };


export const LockContentDocument = gql`
    mutation LockContent($input: LockContentInput!) {
  lockContent(input: $input) {
    result {
      id
      sourceId
      lockType
      schoolId
    }
    errors {
      message
    }
  }
}
    `;
export type LockContentMutationFn = Apollo.MutationFunction<LockContentMutation, LockContentMutationVariables>;

/**
 * __useLockContentMutation__
 *
 * To run a mutation, you first call `useLockContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLockContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lockContentMutation, { data, loading, error }] = useLockContentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useLockContentMutation(baseOptions?: Apollo.MutationHookOptions<LockContentMutation, LockContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LockContentMutation, LockContentMutationVariables>(LockContentDocument, options);
      }
export type LockContentMutationHookResult = ReturnType<typeof useLockContentMutation>;
export type LockContentMutationResult = Apollo.MutationResult<LockContentMutation>;
export type LockContentMutationOptions = Apollo.BaseMutationOptions<LockContentMutation, LockContentMutationVariables>;
export const UnlockContentDocument = gql`
    mutation UnlockContent($id: ID!) {
  unlockContent(id: $id) {
    result {
      id
    }
    errors {
      message
    }
  }
}
    `;
export type UnlockContentMutationFn = Apollo.MutationFunction<UnlockContentMutation, UnlockContentMutationVariables>;

/**
 * __useUnlockContentMutation__
 *
 * To run a mutation, you first call `useUnlockContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlockContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlockContentMutation, { data, loading, error }] = useUnlockContentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnlockContentMutation(baseOptions?: Apollo.MutationHookOptions<UnlockContentMutation, UnlockContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlockContentMutation, UnlockContentMutationVariables>(UnlockContentDocument, options);
      }
export type UnlockContentMutationHookResult = ReturnType<typeof useUnlockContentMutation>;
export type UnlockContentMutationResult = Apollo.MutationResult<UnlockContentMutation>;
export type UnlockContentMutationOptions = Apollo.BaseMutationOptions<UnlockContentMutation, UnlockContentMutationVariables>;